import Vue from 'vue';
import Router from 'vue-router';
import Analyzer from '@/components/Analyzer';
import Generator from '@/components/Generator';
import Reinflector from '@/components/Reinflector';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'Analyzer',
      },
    },
    {
      path: '/analyzer',
      name: 'Analyzer',
      component: Analyzer,
    },
    {
      path: '/generator',
      name: 'Generator',
      component: Generator,
    },
    {
      path: '/reinflector',
      name: 'Reinflector',
      component: Reinflector,
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js